import classNames from "classnames";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Head from "pages/_components/Head";
import Heading from "pages/_components/Heading";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import SelectedAccountsAmount from "pages/charges/_components/SelectedAccountsAmount";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";
import { actions, selectors } from "reducers/checks";
import { selectors as sessionSelectors } from "reducers/session";
import { accountDescription, echeqConceptLabel, echeqShape, findBeneficiary } from "util/checks";
import * as i18n from "util/i18n";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";

const FORM_ID = "echeqs";

class AnulateEcheqAction extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        echeqAction: shape({
            action: string.isRequired,
            echeqList: arrayOf(echeqShape),
            specialAttribute: string.isRequired,
        }).isRequired,
        accounts: arrayOf(shape({})).isRequired,
        userId: string.isRequired,
        environmentCuit: string.isRequired,
        isDesktop: bool.isRequired,
        history: shape({
            location: shape({
                pathname: string,
            }),
        }).isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        submitting: false,
    };

    componentWillMount = () => {
        const { echeqAction } = this.props;

        if (!echeqAction.action) {
            this.handleBack();
        }
    };

    componentDidMount() {
        this.applyV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, echeqAction } = this.props;
        if (
            prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
            prevProps.isDesktop !== isDesktop ||
            prevProps.echeqAction !== echeqAction
        ) {
            this.applyV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell, history } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch, { nextPathname: history?.location?.pathname || "" });
        }
    }

    getShellHeaderTitle = () => {
        const { echeqAction } = this.props;
        if (!echeqAction?.action) {
            return "";
        }
        const titleKey =
            echeqAction?.echeqList?.length > 1
                ? `${FORM_ID}.${echeqAction.action.toLowerCase()}.title.multi`
                : `${FORM_ID}.${echeqAction.action.toLowerCase()}.title`;
        return i18n.get(titleKey);
    };

    applyV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["echeqs"],
            headerTitle: this.getShellHeaderTitle(),
            goBackPath: "/echeqs",
        });
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            dispatch(push("/echeqs"));
        } else {
            dispatch(goBack());
        }
    };

    closeEcheqAction = () => {
        const { dispatch } = this.props;

        dispatch(actions.cleanEcheqAction());
        this.handleBack();
    };

    createAccountDescription = () => {
        const { echeqAction, accounts } = this.props;
        const { specialAttribute } = echeqAction;
        const account = accounts.find((a) => a.idProduct === specialAttribute);

        const { productAlias, number, currency, productType } = account;

        return accountDescription(productAlias, number, currency, productType);
    };

    executeEcheqAction = () => {
        const { dispatch, echeqAction, userId, accounts } = this.props;
        let attribute = echeqAction.specialAttribute;

        if (echeqAction.action === "CUSTODY" || echeqAction.action === "DEPOSIT") {
            const accountSelected = accounts.find((account) => account.idProduct === echeqAction.specialAttribute);
            attribute = accountSelected.cbu;
        }
        this.setState({ submitting: true });
        dispatch(actions.executeActionEcheq({ ...echeqAction, specialAttribute: attribute }, userId));
    };

    renderHeader = () => {
        const { echeqAction, isDesktop, embeddedInV3Shell } = this.props;
        const hideMobileLegacyHeader = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;
        const title =
            echeqAction?.echeqList?.length > 1
                ? `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.title.multi`
                : `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.title`;

        if (isDesktop) {
            return (
                <div className="admin-detail-head px-0">
                    <Head onBack={this.handleBack} onClose={this.closeEcheqAction} />
                    <Head title={title} headerClassName="anulate-echeq-header" centerContentClassName="p-0" />
                </div>
            );
        }

        if (hideMobileLegacyHeader) {
            return null;
        }

        return (
            <Head
                headerClassName="blue-main-header-mobile"
                titleClassName="w-100"
                onBack={this.handleBack}
                title={title}
                emptyRightOption
            />
        );
    };

    render() {
        const { echeqAction, environmentCuit, isDesktop, embeddedInV3Shell } = this.props;
        const { submitting } = this.state;
        return (
            <>
                {this.renderHeader()}
                <div
                    className={classNames({
                        "admin-content-center": !isDesktop,
                        "admin-detail-head px-0": isDesktop,
                        "mb-2 px-6": !isDesktop,
                    })}>
                    <h4>
                        <I18n id="echeqs.action.data.subtitle" />
                    </h4>
                </div>
                {!embeddedInV3Shell && <Notification scopeToShow="echeqs" />}
                <MainContainer>
                    <div className="above-the-fold">
                        {echeqAction?.echeqList?.length > 1 && (
                            <Col xs={12} className="justify-content-right flex">
                                <SelectedAccountsAmount
                                    currency={echeqAction.echeqList[0]?.moneda}
                                    list={echeqAction?.echeqList}
                                    summaryView
                                />
                            </Col>
                        )}
                        {echeqAction?.echeqList?.map((echeq) => {
                            const beneficiary = findBeneficiary(echeq, environmentCuit);
                            return (
                                <Container
                                    className="flex-grow align-items-center container-white with-padding px-2"
                                    gridClassName="form-content">
                                    <>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.cheque_numero`}
                                                data={echeq.cheque_numero}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.beneficiario_nombre`}
                                                data={beneficiary.beneficiarioRazonSocial.replaceAll("#", "Ñ")}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.beneficiario_documento`}
                                                data={beneficiary.beneficiarioDocumento}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.monto`}
                                                data={
                                                    <FormattedAmount
                                                        currency={i18n.get(
                                                            "currency.label.".concat(
                                                                echeq.moneda || echeq.emisor_moneda,
                                                            ),
                                                        )}
                                                        quantity={echeq.monto}
                                                        notBold
                                                    />
                                                }
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.cheque_id`}
                                                data={echeq.cheque_id}
                                            />
                                        </Col>

                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label="echeqs.cheque_tipo"
                                                data={i18n
                                                    .get(`${FORM_ID}.emit.${echeq?.cheque_tipo.toLowerCase()}.label`)
                                                    .toUpperCase()}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label="echeq.emissionDate"
                                                data={<FormattedDate date={echeq.fecha_emision} />}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.fecha_pago`}
                                                data={<FormattedDate showTime={false} date={echeq.fecha_pago} />}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.cheque_caracter`}
                                                data={echeq.cheque_caracter}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.cheque_modo`}
                                                data={i18n.get(`echeqs.${echeq.cheque_modo}.modo`)}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.cheque_concepto`}
                                                data={echeqConceptLabel(echeq.cheque_concepto, "")}
                                            />
                                        </Col>
                                        <Col xs={12} md={3} className="px-2">
                                            <Heading.DataGroup
                                                containerClassName={`transfer-data data-wrapper-flex ${
                                                    isDesktop ? "" : "space-between"
                                                }`}
                                                dataClassName="data-desc"
                                                labelClassName="data-label-medium"
                                                label={`${FORM_ID}.cheque_motivo_pago`}
                                                data={echeq.cheque_motivo_pago}
                                            />
                                        </Col>
                                        {echeqAction.action === "ANULATE-ENDORSE" && (
                                            <>
                                                <Col xs={12} md={3} className="px-2">
                                                    <Heading.DataGroup
                                                        containerClassName={`transfer-data data-wrapper-flex ${
                                                            isDesktop ? "" : "space-between"
                                                        }`}
                                                        dataClassName="data-desc"
                                                        labelClassName="data-label-medium"
                                                        label={`${FORM_ID}.endorse.date`}
                                                        data={
                                                            <FormattedDate
                                                                showTime={false}
                                                                date={echeq.endosos[0]?.fecha_hora}
                                                            />
                                                        }
                                                    />
                                                </Col>
                                                <Col xs={12} md={3} className="px-2">
                                                    <Heading.DataGroup
                                                        containerClassName={`transfer-data data-wrapper-flex ${
                                                            isDesktop ? "" : "space-between"
                                                        }`}
                                                        dataClassName="data-desc"
                                                        labelClassName="data-label-medium"
                                                        label={`${FORM_ID}.type.label`}
                                                        data={i18n
                                                            .get(
                                                                // eslint-disable-next-line max-len
                                                                `${FORM_ID}.${echeq.endosos[0]?.tipo_endoso.toLowerCase()}.label`,
                                                            )
                                                            .toUpperCase()}
                                                    />
                                                </Col>
                                            </>
                                        )}
                                        {echeqAction.action === "ANULATE-CESION" && (
                                            <>
                                                <Col xs={12} md={3} className="px-2">
                                                    <Heading.DataGroup
                                                        containerClassName={`transfer-data data-wrapper-flex ${
                                                            isDesktop ? "" : "space-between"
                                                        }`}
                                                        dataClassName="data-desc"
                                                        labelClassName="data-label-medium"
                                                        label={`${FORM_ID}.cesion.date`}
                                                        data={
                                                            <FormattedDate
                                                                showTime={false}
                                                                date={echeq.cesiones[0]?.fecha_emision_cesion}
                                                            />
                                                        }
                                                    />
                                                </Col>
                                                <Col xs={12} md={3} className="px-2">
                                                    <Heading.DataGroup
                                                        containerClassName={`transfer-data data-wrapper-flex ${
                                                            isDesktop ? "" : "space-between"
                                                        }`}
                                                        dataClassName="data-desc"
                                                        labelClassName="data-label-medium"
                                                        label={`${FORM_ID}.address.label`}
                                                        data={echeq.cesiones[0]?.cesionario_domicilio}
                                                    />
                                                </Col>
                                            </>
                                        )}
                                        <Col
                                            xs={12}
                                            md={echeqAction.action === "ANULATE-ECHEQ" ? 3 : 6}
                                            className="px-2">
                                            {(echeqAction.action === "ANULATE-ENDORSE" ||
                                                echeqAction.action === "ANULATE-ECHEQ") && (
                                                <Heading.DataGroup
                                                    containerClassName={`transfer-data data-wrapper-flex ${
                                                        isDesktop ? "" : "space-between"
                                                    }`}
                                                    dataClassName="data-desc"
                                                    labelClassName="data-label-medium"
                                                    label={`${FORM_ID}.anulate.label`}
                                                    data={echeqAction.specialAttribute}
                                                />
                                            )}
                                        </Col>

                                        <Col xs={12} md={echeqAction.action === "ANULATE-ECHEQ" ? 9 : 3}>
                                            <></>
                                        </Col>
                                    </>
                                </Container>
                            );
                        })}
                        <Container className="align-items-center flex-grow container-white">
                            <div className="admin-content-center pb-3">
                                <I18n
                                    id="confirmation.withoutotp.text"
                                    component="p"
                                    componentProps={{ className: "confirmation__text-without-otp" }}
                                />
                            </div>
                            <Col lg={4} md={9} sm={12}>
                                <Button
                                    type="submit"
                                    bsStyle="primary"
                                    label="global.confirm"
                                    onClick={this.executeEcheqAction}
                                    loading={submitting}
                                    image="images/arrowRight.svg"
                                    imageStyle="mr-2"
                                    className="text-capitalize"
                                />
                            </Col>
                        </Container>
                    </div>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    option: selectors.getEcheqOption(state),
    echeqAction: selectors.getEcheqsToDoActions(state),
    accounts: selectors.getAccounts(state),
    userId: sessionSelectors.getUser(state).userId,
    environmentCuit: selectors.getEnvironmentCuit(state),
});

export default connect(mapStateToProps)(AnulateEcheqAction);
